import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', labelKey: 'common.language.english' },
  { code: 'fr', labelKey: 'common.language.french' },
  { code: 'tr', labelKey: 'common.language.turkish' },
];

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage || i18n.language || 'en';

  const changeLanguage = (lng: string) => {
    void i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  return (
    <div role="group" aria-label={t('common.language.changeLanguage')} style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
      {languages.map((language) => (
        <button
          key={language.code}
          type="button"
          onClick={() => changeLanguage(language.code)}
          disabled={currentLanguage === language.code}
          aria-pressed={currentLanguage === language.code}
          style={{
            padding: '0.55rem 0.9rem',
            borderRadius: 10,
            border: currentLanguage === language.code ? '2px solid #0f172a' : '1px solid #cbd5e1',
            background: currentLanguage === language.code ? '#0f172a' : '#ffffff',
            color: currentLanguage === language.code ? '#ffffff' : '#0f172a',
            cursor: currentLanguage === language.code ? 'not-allowed' : 'pointer',
          }}
        >
          {t(language.labelKey)}
        </button>
      ))}
    </div>
  );
}
